import cn from 'classnames'
import classes from './KeyBenefitsSection.module.scss'

const Item = ({
  title,
  description,
}: {
  title?: string
  description?: string
}) => (
  <li className={cn('container col-12 col-lg-3 c-pl-5 c-pr-4', classes.border)}>
    <div className='c-my-5'>
      <h2 className='mc-mb-3 c-text-h5 c-body-bold'>{title}</h2>
      <p className='c-text-color--tint-3 c-body'>{description}</p>
    </div>
  </li>
)

export const KeyBenefitsSection = ({
  keyBenefits = [],
}: {
  keyBenefits?: { title?: string; description?: string }[]
}) =>
  keyBenefits && (
    <div className='d-flex justify-content-center c-mt-7'>
      <ul className='container row no-gutters d-flex'>
        {keyBenefits.map((item, idx) => (
          <Item key={idx} title={item.title} description={item.description} />
        ))}
      </ul>
    </div>
  )
